
export default function SocialProofSection() {
  const results = [
    { metric: "300%", label: "Average Revenue Increase" },
    { metric: "75+", label: "Companies Transformed" },
    { metric: "12 Months", label: "Average ROI Timeline" },
    { metric: "95%", label: "Client Retention Rate" }
  ];

  const logos = [
    { name: "TechConsult Pro", industry: "Technology Consulting" },
    { name: "Legal Solutions", industry: "Legal Services" },
    { name: "Growth Partners", industry: "Business Consulting" },
    { name: "Digital Marketing Pros", industry: "Marketing Agency" },
    { name: "Financial Advisory", industry: "Financial Services" },
    { name: "Consulting Dynamics", industry: "Management Consulting" }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        {/* Results Banner */}
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-[#1B365D] mb-12">Proven Results for Service Companies</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {results.map((result, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl font-bold text-[#2BB6A3] mb-2">{result.metric}</div>
                <div className="text-gray-600 font-medium">{result.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Client Logos */}
        <div className="text-center">
          <p className="text-gray-600 mb-8 text-lg">Trusted by Sacramento's Leading Service Companies</p>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {logos.map((logo, index) => (
              <div key={index} className="text-center">
                <div className="bg-white rounded-lg p-6 shadow-sm border h-24 flex items-center justify-center mb-2">
                  <div className="text-[#1B365D] font-bold text-lg">{logo.name}</div>
                </div>
                <div className="text-xs text-gray-500">{logo.industry}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
